<!-- 
  跟进提醒
 -->

<template>
  <div class="remind">
    <el-dialog title="跟进提醒" :visible.sync="dialogVisible" :modal="modal">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px" class="custom-form">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item :label="getName(name)">
          <span class="text">{{customer.title}}{{multCustomers}}</span>
        </el-form-item>
        <el-form-item label="执行人" prop="reminder">
          <div>
            <el-checkbox v-model="form.reminder.manager" @change="manualTrigger">负责人</el-checkbox>
            <el-checkbox v-model="form.reminder.cooper" @change="manualTrigger">协同人</el-checkbox>
            <el-checkbox v-model="isCustom" @change="manualTrigger">自定义人员</el-checkbox>
          </div>
          <el-select
            v-if="isCustom"
            v-model="form.userIds"
            multiple
            filterable
            remote
            placeholder="请选择自定义人员"
            :remote-method="remoteMethod"
            :loading="loading">
            <el-option
              v-for="item in userList"
              :key="item.value"
              :label="item.value"
              :value="item.userId">
              <dl class="custom-option">
                <dt class="title">{{item.value}}</dt>
                <dd class="avatar">
                  <img :src="item.avatar" width="32" height="32">
                </dd>
                <dd class="department">
                  <span v-for="d in item.department">{{d}}</span>
                </dd>
              </dl>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="跟进时间" prop="followTime">
          <el-date-picker
            v-model="form.followTime"
            :editable="false"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="disableBefore"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="提醒" prop="notifyType">
          <el-select v-model="form.notifyType" placeholder="请选择">
            <el-option
              v-for="item in notifyType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提醒时间" v-if="form.notifyType === 5" prop="notifyTime">
          <el-date-picker
            v-model="form.notifyTime"
            :editable="false"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="disableBefore"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="重复提醒" prop="loopUnit">
          <el-select v-model="form.loopUnit" placeholder="请选择">
            <el-option
              v-for="item in loopUnit"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="循环次数" v-if="form.loopUnit">
          <el-input-number v-model="form.loopNum" :min="1" :max="30"></el-input-number>
        </el-form-item>        
        <el-form-item label="备注" prop="content">
          <el-input type="textarea" v-model="form.content"></el-input>
        </el-form-item>
        <el-form-item v-if="['purchase', 'supplier'].indexOf(moduleName) === -1" label="加入访客">
          <el-checkbox v-model="communicatePlan">将此次提醒加入访客计划</el-checkbox>
        </el-form-item>        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">推 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'

export default {
  created () {
    this.getUserList()
  },
  props: {
    customer: {
      type: Object
    },
    // 是否显示遮罩
    modal: {
      type: Boolean,
      default: true
    },
    // 接收父组件传过来的模块名
    moduleName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: true,
      isCustom: false, // 自定义执行人
      // 添加or删除负责人
      communicatePlan: false,
      remindTime: new Date(), // 自定义提醒时间
      form: {
        title: '',
        refIds: [],
        reminder: {
          manager: true,
          cooper: false
        },
        userIds: [],
        followTime: '',
        notifyType: 0,
        notifyTime: '',
        loopUnit: 0,
        content: '',
        loopNum: 1
      },
      // 是否初始化
      isInit: true,
      notifyType: [
        {
          label: '提前15分钟',
          value: 0
        },
        {
          label: '提前1小时',
          value: 1
        },
        {
          label: '提前1天',
          value: 2
        },
        {
          label: '提前3天',
          value: 3
        },
        {
          label: '提前1周',
          value: 4
        },
        {
          label: '自定义时间',
          value: 5
        }
      ],
      loopUnit: [
        {
          label: '不重复提醒',
          value: 0
        },
        {
          label: '每天提醒',
          value: 1
        },
        {
          label: '每周提醒',
          value: 2
        },
        {
          label: '每月提醒',
          value: 3
        },
        {
          label: '每年提醒',
          value: 4
        }
      ],
      userList: [],
      rules: {
        title: { required: true, message: '请输入标题', trigger: 'blur' },
        reminder: { type: 'object', validator: this.requireReminder },
        followTime: { required: true, message: '请选择跟进时间', trigger: 'change' },
        notifyType: { type: 'number', required: true, message: '请选择提醒类型', trigger: 'change' },
        loopUnit: { type: 'number', required: true, message: '请选择重复提醒间隔', trigger: 'change' },
        content: [
          { required: true, message: '请输入备注内容', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        notifyTime: { required: true, message: '请选择提醒时间', trigger: 'change' }
      },
      disableBefore: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  computed: {
    refType () {
      if (this.moduleName === 'customerApi') {
        return 1
      } else if (this.moduleName === 'opportunityApi') {
        return 3
      } else if (this.moduleName === 'contractApi') {
        return 2
      } else if (this.moduleName === 'contactApi') {
        return 4
      } else if (this.moduleName === 'supplier') {
        return 6
      } else if (this.moduleName === 'purchase') {
        return 7
      } else {
        throw new Error(this.moduleName + ' the refType is not defined')
      }
    },

    // 模块名
    name () {
      if (this.moduleName === 'customerApi') {
        return '客户'
      } else if (this.moduleName === 'opportunityApi') {
        return '机会'
      } else if (this.moduleName === 'contractApi') {
        return '合同'
      } else if (this.moduleName === 'purchase') {
        return '采购合同'
      } else if (this.moduleName === 'supplier') {
        return '供应商'
      } else {
        throw new Error(this.moduleName + ' unknow this module')
      }
    },

    multCustomers () {
      if (this.customer.id && this.customer.id.length > 1) {
        return ` 等${this.customer.id.length}个${this.name}`
      } else {
        return ''
      }
    }
  },
  methods: {
    showDialog () {
      this.dialogVisible = true
    },

    // 获得名称
    getName (name) {
      if (name === '采购合同') {
        return name + '编号'
      } else {
        return name + '名称'
      }
    },

    // 远程搜索
    remoteMethod (query) {
      this.loading = true
      this.getUserList(query)
    },
    // 获取员工数据
    getUserList (query) {
      let url = `/user/getStaffsAjax.html`
      let params = {
        nameLike: query || '',
        userIds: []
      }
      api.post(url, params, (data) => {
        this.loading = false
        this.dialogVisible = true
        this.userList = data.result

        // 初始化结束
        if (this.isInit) {
          this.isInit = false
          this.getUserList()
        }
      })
    },
    // 提交
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sendData()
        } else {
          Message({
            type: 'error',
            message: '输入有误，请检查后重新提交！'
          })
          return false
        }
      })
    },
    // 发送数据
    sendData () {
      const url = `/communicateApi/pushNotifySave.html`

      let params = Object.assign({}, this.form)

      // 检查自定义人员状态，如果未选择，则清空自定义人员
      if (!this.isCustom) {
        this.form.userIds = []
      }
      params.selectType = this.refType
      api.post(url, params, (data) => {
        const that = this
        Message({
          type: 'success',
          message: '保存成功！',
          duration: 1000,
          onClose: function () {
            that.dialogVisible = false
            that.$emit('refresh')
          }
        })

        // 提交访客计划
        if (this.communicatePlan) {
          this.sendCommunicatePlan()
        }
      })
    },
    // 提交访客计划
    sendCommunicatePlan () {
      const url = `/communicatePlanApi/save.html`
      const params = {
        refIds: this.form.refIds,
        reminder: this.form.reminder,
        userIds: this.form.userIds,
        planDateTime: this.form.followTime,
        memo: this.form.content,
        selectType: this.refType
      }
      api.post(url, params, (data) => {})
    },

    // 手动触发执行人验证
    manualTrigger () {
      setTimeout(() => {
        this.$refs.ruleForm.validateField('reminder')
      }, 50)
    },

    // 执行人必填验证
    requireReminder (rules, value, callback) {
      if (value.manager || value.cooper || this.form.userIds.length) {
        callback()
      } else {
        callback(new Error('请选择执行人！'))
      }
    }
  },
  watch: {
    // 初始化时，给负责人赋值
    dialogVisible () {
      if (this.dialogVisible === true) {
        // 客户id ,如果是number，转为数组再提交
        if (typeof this.customer.id === 'number') {
          this.customer.id = [this.customer.id]
        }
        this.form.refIds = this.customer.id
        if (this.customer.id && this.customer.id.length > 1) {
          this.form.title = `${this.customer.title}等${this.customer.id.length}个${this.name}的跟进提醒`
        } else {
          this.form.title = this.customer.title + '的跟进提醒'
        }
      } else {
        this.$emit('closeDialog')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .remind {
    .el-dialog--small {
      width: 620px;
    }
  }
  .custom-option {
    position: absolute;
    box-sizing: border-box;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    padding-left: 50px;
    .avatar {
      position: absolute;
      left: 8px;
      top: 2px;
      img {
        display: block;
      }
    }
    .title {
      font-size: 14px;
      line-height: 1.3;
    }
    .department {
      font-size: 12px;
      color: #999;
      overflow: hidden;
      white-space: nowrap;
      text-overflow:ellipsis;
      height: 16px;
      line-height: 16px;
      span {
        margin-right: 2px;
        line-height: 16px!important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// remind.vue?6a1e3674